import React from 'react';

export default () => (
  <svg width="24px" height="24px" fill="currentColor" viewBox="0 0 79.642 79.643">
    <path d="M67.993 11.653a39.839 39.839 0 100 56.339 39.883 39.883 0 000-56.339zm-4.347 51.994a33.695 33.695 0 110-47.651 33.732 33.732 0 010 47.651zM56.8 53.338a2.613 2.613 0 01-2.612 2.612h-28.73a2.612 2.612 0 110-5.224h28.73a2.613 2.613 0 012.612 2.612zM25.206 31.052l-3.892-3.892a2.3632 2.3632 0 113.342-3.342l7.1 7.1c.011.011.017.023.028.034a4.657 4.657 0 11-6.58.1zm33.121-7.233a2.364 2.364 0 010 3.342l-3.891 3.891a4.656 4.656 0 11-6.579-.1c.011-.011.016-.023.027-.034l7.1-7.1a2.362 2.362 0 013.343.001z" />
  </svg>
);
